/**
* 左边菜单
*/ 
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
      
    </div>
    <p class="title">禾睦笙智能管理系统</p>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname"  v-permission="menu.rules">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
              
          <el-badge :value="overdueNum" class="item"  v-if="chmenu.Badge===true">
  
        </el-badge>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from '../api/userFun'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: [],
      overdueNum:0,
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: 'li-icon-xiangmuguanli',
          menuname: '业务员管理',
          hasThird: null,
          url: null,
          rules:'Modify_salesperson',
          menus: [
            {
              menuid: 2,
              icon: 'icon-cat-skuQuery',
              menuname: '业务员列表',
              hasThird: 'N',
              url: 'system/user',
              menus: null
            }
          ]
        },
        {
          menuid: 33,
          icon: 'li-icon-dingdanguanli',
          menuname: '宽带管理',
          hasThird: null,
          url: null,
          rules:'Add_order',
          menus: [
             {
              menuid: 34,
              icon: 'icon-order-manage',
              menuname: '新增宽带',
              hasThird: 'N',
              url: 'order/addOrder',
              menus: null
            },
            {
              menuid: 35,
              icon: 'icon-order-manage',
              menuname: '宽带订单',
              hasThird: 'N',
              url: 'order/Order',
              menus: null
            },
             {
              menuid: 135,
              icon: 'icon-order-manage',
              menuname: '网站订单',
              hasThird: 'N',
              url: 'order/baiduorder',
              menus: null
            },
             {
              menuid: 36,
              icon: 'icon-order-manage',
              menuname: '超5天未核销订单',
              hasThird: 'N',
              Badge:true,
              url: 'order/Order?do=overdue',
              menus: null
            }
          ]
        },
        {
          menuid: 71,
          icon: 'li-icon-xitongguanli',
          menuname: '系统管理',
          hasThird: null,
          url: null,
          rules:'Add_administrator',
          menus: [
              {
              menuid: 100,
              icon: 'icon-cus-manage',
              menuname: '商品管理',
              hasThird: 'N',
              url: 'system/goods',
              menus: null
            },
            {
              menuid: 72,
              icon: 'icon-cus-manage',
              menuname: '管理员',
              hasThird: 'N',
              url: 'system/admin',
              menus: null
            },
            // {
            //   menuid: 174,
            //   icon: 'icon-cms-manage',
            //   menuname: '菜单管理',
            //   hasThird: 'N',
            //   url: 'system/menu',
            //   menus: null
            // },
            {
              menuid: 73,
              icon: 'icon-news-manage',
              menuname: '角色管理',
              hasThird: 'N',
              url: 'system/role',
              menus: null
            },
            {
              menuid: 76,
              icon: 'icon-cms-manage',
              menuname: '项目设置',
              hasThird: 'N',
              url: 'system/project',
              menus: null
            },
             {
              menuid: 80,
              icon: 'icon-cms-manage',
              menuname: '归属地设置',
              hasThird: 'N',
              url: 'system/belong',
              menus: null
            },
            {
              menuid: 81,
              icon: 'icon-cms-manage',
              menuname: '供应商设置',
              hasThird: 'N',
              url: 'system/provide',
              menus: null
            },
            {
              menuid: 108,
              icon: 'icon-cms-manage',
              menuname: '套餐设置',
              hasThird: 'N',
              url: 'system/meal',
              menus: null
            },
             {
              menuid: 88,
              icon: 'icon-cms-manage',
              menuname: '订单状态',
              hasThird: 'N',
              url: 'system/status',
              menus: null
            }
          ]
        },
          {
          menuid: 55,
          icon: 'li-icon-xiangmuguanli',
          menuname: '数据中心',
          hasThird: null,
          url: null,
          rules:'Data_export',
          menus: [
            {
              menuid: 2,
              icon: 'icon-cat-skuQuery',
              menuname: '数据管理',
              hasThird: 'N',
              url: 'datacenter/export',
              menus: null
            }
          ]
        },
      
     
      ],
      msg: 'success'
    }
          this.allmenu = res.data
    
    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })

    this.$root.Bus.$on('overdue', value => {
      this.overdueNum = value
    })

     // console.log(this.$root.Bus);
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.title{
  color: #fff;
  text-align: center;
  padding: 5px;
  margin: 0;
  margin-left:10px ;
  font-size: 1.2rem;
  border: 1px solid #fff;
  display:inline-block;
}
.logobox {
  height: 80px;
  line-height: 80px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
  padding-bottom: 10px;
}
.logoimg {
  height: 80px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue